import { DisabledPrompt, useRoute } from "@bcm-dev/bcms-vite";
import FormContainer, { FormButtonContainer, FormRow } from "components/shared/containers/FormContainer";
import MainContentContainer, { MainContentHeader } from "components/shared/containers/MainContentContainer";
import ControlToggleView from "components/shared/views/BaseToggleView/components/ControlToggleView";
import { UICancelButton, UIPrimaryButton } from "components/ui/UIButton";
import React, { useState } from "react";
import { SVGAsset } from "res";

import "./styles.css";
/**
 * @function TransactionControlsPage
 * @return {React.Component}
 * @exported true
 * @description The main component for TransactionControlsPage
 */

export default function TransactionControlsPage(props) {
  const navigate = useRoute();

  const [ state, setState ] = useState(true);
  const toggle = value => setState(value);

  const cancel = evt => navigate(-1);
  const disabledChevron = <DisabledPrompt><SVGAsset id="RightChevronIcon" className="clickable chevron-icon" /></DisabledPrompt>

  return (
    <MainContentContainer className="transaction-controls-page" header={
      <MainContentHeader text="Transaction Controls" />
    }>
      <FormContainer>
        <ControlToggleView 
          mainText="Enable Transaction Controls" 
          subText="Allow selected transaction types." 
          onChange={ toggle }
          icon={ disabledChevron } 
          checked={true}
          dataPoint="Transaction_Controls"
          className="hide-chevron-icon" />

        <FormRow>
          <ControlToggleView 
            mainText="In Store" 
            subText="Department stores, pharmacies and other card purchases si..." 
            checked={ state }
            icon={ disabledChevron }
            dataPoint="Transaction_Controls_In_Store"
            className={ !state ? "disabled" : "" } />
        </FormRow>

        <FormRow>
          <ControlToggleView 
            mainText="Online / eCommmerce" 
            subText="Online bill payments, online shopping, and other online purc..." 
            checked={ state } 
            icon={ disabledChevron } 
            dataPoint="Transaction_Controls_Online"
            className={ !state ? "disabled" : "" }/>
        </FormRow>

        <FormRow>
          <ControlToggleView 
            mainText="Recurring / Autopay" 
            subText="Automated bills, monthly subscriptions, and other purchases..." 
            checked={ state }
            icon={ disabledChevron } 
            dataPoint="Transaction_Controls"
            className={ !state ? "disabled" : "" }/>
        </FormRow>

        <FormRow>
          <ControlToggleView 
            mainText="ATM" 
            subText="Cash dispensers, cash kiosks, and ATM withdrawals. ATM pur..." 
            checked={ state }
            icon={ disabledChevron } 
            dataPoint="Transaction_Controls_ATM"
            className={ !state ? "disabled" : "" }/>
        </FormRow>

        <FormRow>
          <ControlToggleView 
            mainText="Other" 
            subText="Other purchases that cannot be defined by a different transa..." 
            checked={ state }
            icon={ disabledChevron }
            dataPoint="Transaction_Controls_Other"
            className={ !state ? "disabled" : "" } />
        </FormRow>

        <FormButtonContainer>
          <DisabledPrompt>
            <UIPrimaryButton text="Apply"
            dataPoint="Transaction_Controls_Apply" />
          </DisabledPrompt>

          <UICancelButton text="Cancel" onClick={ cancel } 
            dataPoint="Transaction_Controls_Cancel"/>
        </FormButtonContainer>
      </FormContainer>
    </MainContentContainer>
  );
}